var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioCheckSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.78395 .62082 -.57909 .81527 4.39 11.08)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M1-1h3.725"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.63026 -.77639 .74143 .67103 8.877 14.634)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "square",
    d: "M1-1h8.681"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioCheckSelected);
export default __webpack_public_path__ + "static/media/radio-check-selected.9cec78f464611a53ae803a53ad77c4c4.svg";
export { ForwardRef as ReactComponent };